// ? horarios -> Sunday = 0, ... , Saturday = 6

export const lugares = [
  {
    name: {
      en: "Congress Center",
      es: "Centro de Congresos",
    },
    desc: {
      en:
        "Iis qui facit eorum claritatem Investigationes: demonstraverunt lectores legere me lius quod.",
      es:
        "Iis qui facit eorum claritatem Investigationes: demonstraverunt lectores legere me lius quod.",
    },
    color: "blue",
    open: true,
    servicios: ["bathroom", "printers"],
    horarios: [
      [1, 24],
      [1, 24],
      [1, 24],
      [1, 24],
      [1, 24],
      [1, 24],
      [1, 24],
    ],
    coords: [
      [20.732895, -103.456267],
      [20.73248, -103.455965],
      [20.732869, -103.45541],
      [20.7333, -103.455776],
    ],
  },
  {
    name: {
      en: "Gym",
      es: "Gimnasio",
    },
    desc: {
      en:
        "Iis qui facit eorum claritatem Investigationes: demonstraverunt lectores legere me lius quod.",
      es:
        "Iis qui facit eorum claritatem Investigationes: demonstraverunt lectores legere me lius quod.",
    },
    color: "red",
    open: true,
    servicios: ["bathroom"],
    horarios: [
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
    ],
    coords: [
      [20.736284, -103.455898],
      [20.735463, -103.455966],
      [20.735404, -103.455617],
      [20.736248, -103.455524],
    ],
  },
  {
    name: {
      en: "Library",
      es: "Biblioteca",
    },
    desc: {
      en:
        "Iis qui facit eorum claritatem Investigationes: demonstraverunt lectores legere me lius quod.",
      es:
        "Iis qui facit eorum claritatem Investigationes: demonstraverunt lectores legere me lius quod.",
    },
    color: "green",
    open: false,
    servicios: ["bathroom", "computers", "printers"],
    horarios: [
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
    ],
    coords: [
      [20.735269, -103.455015],
      [20.734837, -103.455036],
      [20.734782, -103.454457],
      [20.735184, -103.454446],
    ],
  },
  {
    name: {
      en: "Cultural Center",
      es: "Difusión Cultural",
    },
    desc: {
      en:
        "Iis qui facit eorum claritatem Investigationes: demonstraverunt lectores legere me lius quod.",
      es:
        "Iis qui facit eorum claritatem Investigationes: demonstraverunt lectores legere me lius quod.",
    },
    color: "purple",
    open: true,
    servicios: [],
    horarios: [
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
      [7, 21],
    ],
    coords: [
      [20.735332, -103.457545],
      [20.734958, -103.457572],
      [20.734933, -103.457202],
      [20.735291, -103.45718],
    ],
  },
];
